<template>
  <div class="p-3 bg-white">
    <shared-messages-category-add
      @addMessageCategorySuccess="addMessageCategorySuccess"
    ></shared-messages-category-add>

    <div class="text-center">
      <vs-button id="addMessageCategoryButton" color="primary" type="filled" @click.prevent="addCategory">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelAddCategory">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import SharedMessagesCategoryAdd from '@/views/Shared/Messages/Category/Add'
import { EventBus } from '@/../eventbus'

export default {
  name: 'Window.Messages.Category.Add',
  components: {
    SharedMessagesCategoryAdd
  },
  mounted () {
    EventBus.$emit('initMessageCategoryFormData')
  },
  methods: {
    addCategory () {
      EventBus.$emit('initAddMessageCategory')
    },
    addMessageCategorySuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_message_category_table')
      window.close()
    },
    cancelAddCategory () {
      this.$windowOpenerHelper.notifyOpener('reload_message_category_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
